module.exports = __webpack_public_path__ + "img/u4a.400f9d70.jpg";